import { BuiAvatar } from "@btnet/blueprint-components";

import { type IBTAvatarProps } from "./BTAvatar.types";

export function BTAvatar(props: IBTAvatarProps) {
  return <BuiAvatar {...props} />;
}
